export function inArray(array:Array<any>, find:any){
    return array.indexOf(find) !== -1;
}